// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://smfuwrmdonlmchctxvjq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNtZnV3cm1kb25sbWNoY3R4dmpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcwNzEyMTMsImV4cCI6MjA2MjY0NzIxM30.p-pWEpQGzb4MnikQA2tdh0bj8NmMJZluux6XgyEbWBs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});